import { render } from "./HomeBanner.vue?vue&type=template&id=1b822571&scoped=true"
import script from "./HomeBanner.vue?vue&type=script&lang=js"
export * from "./HomeBanner.vue?vue&type=script&lang=js"

import "./HomeBanner.vue?vue&type=style&index=0&id=1b822571&scoped=true&lang=scss"

import exportComponent from "D:\\Spadej Work\\SPJWEB\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b822571"]])

export default __exports__